<template>
  <div class="bg-b-lue" v-on:click.self="close()">
    <div class="frame-35628" v-if="companyName !== ''">
      <CompletedAnimationJSON id="completed-animation" />
      <div class="company-name-wrapper" style="margin-top: 10px">
        {{$t("pass-changed-success")}}
      </div>
      <div
        class="button"
        style="
          background-color: white;
          border: 2px solid #224096;
          padding: 14px 0px;
        "
        v-on:click.prevent="close()"
      >
        <div class="button-text" style="color: #224096">{{$t("close")}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import CompletedAnimationJSON from "@/assets/Animation/CompletedAnimation.vue";

export default {
  name: "PasswordChangeStatus",
  components: {
    CompletedAnimationJSON,
  },
  props: {},
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.bg-b-lue {
  background: rgba(0, 0, 0, 8%);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  z-index: 9999;
}
.frame-35628 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  max-width: 420px;
  position: absolute;
  background: #ffffff;
  border-radius: 24px;
  position: relative;
  box-shadow: 0px 24px 24px 0px rgba(17, 54, 90, 0.2);
  padding: 2rem 3rem;
  gap: 25px;
}
.company-name-wrapper {
  color: var(--Dark-Blue, #224096);
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 5px;
}
.button {
  border-radius: 13px;
  padding: 16px 0px 16px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 150px;
  width: 100%;
  cursor: pointer;
}
.button-text {
  color: #ffffff;
  text-align: center;
  font-family: "NunitoSans-SemiBold", sans-serif;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
}

@media only screen and (max-width: 767px) {
  .frame-35628 {
    width: 75%;
    padding: 1rem 2rem;
  }
  #completed-animation {
    width: 75px;
    height: 75px;
  }
  .company-name-wrapper {
    font-size: 16px !important;
  }
  .report-delivery-time {
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-size: 14px;
  }
  .button {
    width: 70%;
    padding: 10px 0 !important;
  }
  .button-text {
    font-size: 14px;
  }
}
</style>
